import config from 'config';

import AuthGateway from './Auth';
import ProfileGateway from './Profile';
import OutletGateway from './Outlet';

const baseUrl = config.baseUrl as string;

const auth = new AuthGateway(baseUrl);
const profile = new ProfileGateway(baseUrl);
const outlet = new OutletGateway(baseUrl);

export default {
    auth,
    profile,
    outlet,
};
